<div class="qa-sheet">
  <div
    class="qa-sheet__handle"
    (touchstart)="onHandleTouchStart($event)"
    (touchmove)="onHandleTouchMove($event)"
    (touchend)="onHandleTouchEnd()"
    (touchcancel)="onHandleTouchEnd()"
    (mousedown)="onHandleMouseDown($event)"></div>

  <div
    class="qa-sheet__header"
    (touchstart)="onHandleTouchStart($event)"
    (touchmove)="onHandleTouchMove($event)"
    (touchend)="onHandleTouchEnd()"
    (touchcancel)="onHandleTouchEnd()"
    (mousedown)="onHandleMouseDown($event)">
    <h5 class="qa-sheet__title">{{ 'mobileNav.customizeTitle' | translate }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
  </div>

  <p class="qa-sheet__hint">{{ 'mobileNav.customizeHint' | translate }}</p>

  <div class="qa-sheet__search">
    <i class="fa fa-search qa-sheet__search-icon"></i>
    <input
      type="text"
      class="qa-sheet__search-input"
      [placeholder]="'mobileNav.customizeSearchPlaceholder' | translate"
      [value]="searchTerm"
      (input)="onSearchChange($any($event.target).value)" />
    @if (searchTerm) {
      <button type="button" class="qa-sheet__search-clear" (click)="clearSearch()">
        <i class="fa fa-times"></i>
      </button>
    }
  </div>

  <div class="qa-sheet__body" cdkScrollable>
    @if (!hasSearchResults) {
      <p class="qa-sheet__no-results">
        {{ 'mobileNav.customizeNoResults' | translate }}
      </p>
    }

    @for (topGroup of groups; track topGroup.topGroupId) {
      <div class="qa-top-group">
        <h6 class="qa-top-group__title">{{ topGroup.topGroupTitleKey | translate }}</h6>

        @for (subGroup of topGroup.subGroups; track subGroup.groupId) {
          @if (subGroup.pages.length) {
            <div class="qa-group">
              @if (subGroup.groupId !== topGroup.topGroupId) {
                <h6 class="qa-group__title">{{ subGroup.groupTitleKey | translate }}</h6>
              }
              <div
                class="qa-group__grid"
                cdkDropList
                [id]="groupListId(subGroup.groupId)"
                [cdkDropListData]="subGroup.pages"
                [cdkDropListConnectedTo]="[selectedTrayId]"
                cdkDropListSortingDisabled>
                @for (page of subGroup.pages; track page.id) {
                  <button
                    type="button"
                    class="qa-item"
                    cdkDrag
                    [cdkDragStartDelay]="dragStartDelay"
                    [cdkDragData]="page"
                    [cdkDragDisabled]="isSelected(page)"
                    [class.qa-item--selected]="isSelected(page)"
                    [class.qa-item--armed]="armedPageId === page.id"
                    [class.qa-item--blocked]="!isSelected(page) && isFull"
                    (cdkDragStarted)="captureTraySlotCenters()"
                    (pointerdown)="armPage(page)"
                    (pointerup)="disarm()"
                    (pointerleave)="disarm()"
                    (pointercancel)="disarm()"
                    (click)="toggle(page)">
                    <span class="qa-item__toggle-badge">
                      <i class="fa" [ngClass]="isSelected(page) ? 'fa-check' : 'fa-plus'"></i>
                    </span>
                    <span class="qa-item__content">
                      <shared-quick-access-icon [page]="page"></shared-quick-access-icon>
                      <span class="qa-item__label">{{ page.titleKey | translate }}</span>
                    </span>
                  </button>
                }
              </div>
            </div>
          }
        }
      </div>
    }
  </div>

  <div class="qa-sheet__tray">
    <div class="qa-sheet__tray-top">
      <div class="qa-sheet__tray-label" [class.qa-sheet__tray-label--full]="isFull">
        {{ 'mobileNav.selectedLabel' | translate }} ({{ selectedPages.length }}/{{ maxSelected }})
      </div>

      <div class="qa-nav-mode-group">
        <span class="qa-nav-mode-group__label">{{
          'mobileNav.navModeGroupLabel' | translate
        }}</span>
        <div
          class="qa-nav-mode"
          role="group"
          [attr.aria-label]="'mobileNav.navModeGroupLabel' | translate">
          <button
            type="button"
            class="qa-nav-mode__option"
            [class.qa-nav-mode__option--active]="navMode === navModeBottomBar"
            [attr.aria-pressed]="navMode === navModeBottomBar"
            [title]="'mobileNav.navModeBottomBar' | translate"
            (click)="selectNavMode(navModeBottomBar)">
            <i class="fa fa-minus"></i>
          </button>
          <button
            type="button"
            class="qa-nav-mode__option"
            [class.qa-nav-mode__option--active]="navMode === navModeFloatingButton"
            [attr.aria-pressed]="navMode === navModeFloatingButton"
            [title]="'mobileNav.navModeFloatingButton' | translate"
            (click)="selectNavMode(navModeFloatingButton)">
            <i class="fa fa-circle"></i>
          </button>
          <button
            type="button"
            class="qa-nav-mode__option"
            [class.qa-nav-mode__option--active]="navMode === navModeHidden"
            [attr.aria-pressed]="navMode === navModeHidden"
            [title]="'mobileNav.navModeHidden' | translate"
            (click)="selectNavMode(navModeHidden)">
            <i class="fa fa-eye-slash"></i>
          </button>
        </div>
      </div>
    </div>
    @if (limitReached) {
      <p class="qa-sheet__limit" role="status" aria-live="polite">
        <i class="fa fa-exclamation-circle"></i>
        {{ 'mobileNav.customizeLimitNotice' | translate: { max: maxSelected } }}
      </p>
    }

    @if (navMode === navModeHidden) {
      <p class="qa-sheet__tray-hint">{{ 'mobileNav.navModeHiddenNote' | translate }}</p>

      <div class="qah">
        <h2 class="visually-hidden">{{ 'mobileNav.navModeHiddenA11y' | translate }}</h2>

        <div class="qah__trigger">
          <span class="qah__avatar"><i class="fa fa-user"></i></span>
          <i class="fa fa-angle-down qah__caret"></i>
        </div>

        <div class="qah__menu">
          <div class="qah__row">
            <i class="fa fa-user-o"></i>
            <span>{{ 'profile.account' | translate }}</span>
          </div>
          <div class="qah__row">
            <span class="qah__icon-stack">
              <i class="fa fa-envelope-o"></i>
              <span class="qah__badge bg-danger">99+</span>
            </span>
            <span>{{ 'profile.messages' | translate }}</span>
          </div>
          <div class="qah__row qah__row--target">
            <i class="fa fa-sliders"></i>
            <span>{{ 'profile.customizeMenu' | translate }}</span>
          </div>
          <div class="qah__row">
            <i class="fa fa-globe"></i>
            <span>{{ 'profile.language' | translate }}:{{ demoLang }}</span>
          </div>
          <div class="qah__row">
            <i class="fa fa-sun-o"></i>
            <span>{{ 'profile.darkMode' | translate }}</span>
          </div>
          <div class="qah__row qah__row--logout">
            <i class="fa fa-sign-out"></i>
            <span>{{ 'profile.logOut' | translate }}</span>
          </div>
        </div>

        <span class="qah__cursor" aria-hidden="true"></span>
      </div>
    } @else {
      <p class="qa-sheet__tray-hint">
        @if (navMode === navModeFloatingButton) {
          {{ 'mobileNav.navModeFloatingNote' | translate }}
        } @else {
          {{ 'mobileNav.navModeBottomBarNote' | translate }}
        }
      </p>

      <div
        class="qa-tray-bar"
        [class.qa-tray-bar--floating]="navMode === navModeFloatingButton"
        [id]="selectedTrayId"
        cdkDropList
        cdkDropListOrientation="horizontal"
        cdkDropListSortingDisabled
        [cdkDropListData]="slots"
        (cdkDropListDropped)="onTrayDropped($event)">
        @for (slot of slots; track $index) {
          @if (slot) {
            <div
              class="qa-tray-item"
              cdkDrag
              [cdkDragStartDelay]="dragStartDelay"
              [cdkDragData]="slot"
              [class.qa-tray-item--picked]="pickedIndex === $index"
              [class.qa-tray-item--elevated]="$index === elevatedIndex"
              [class.qa-tray-item--dropped]="droppedIndex === $index"
              [class.qa-tray-item--shifted]="shiftedIndexes.has($index)"
              [class.qa-tray-item--armed]="armedSlotIndex === $index"
              (cdkDragStarted)="captureTraySlotCenters()"
              (cdkDragEnded)="onDragEnded()"
              (pointerdown)="armSlot($index)"
              (pointerup)="disarm()"
              (pointerleave)="disarm()"
              (pointercancel)="disarm()"
              (click)="onSlotTap($index)">
              <button
                type="button"
                class="qa-tray-item__remove"
                [attr.aria-label]="'mobileNav.customizeSlotRemove' | translate"
                [title]="'mobileNav.customizeSlotRemove' | translate"
                (click)="$event.stopPropagation(); removeAt($index)">
                <i class="fa fa-times"></i>
              </button>
              <button
                type="button"
                class="qa-tray-item__edit"
                [attr.aria-label]="'mobileNav.customizeSlotEdit' | translate"
                [title]="'mobileNav.customizeSlotEdit' | translate"
                (pointerdown)="$event.stopPropagation()"
                (click)="$event.stopPropagation(); openSlotEditor($index)">
                <i class="fa fa-pencil"></i>
              </button>
              <span class="qa-tray-item__content">
                <shared-quick-access-icon [page]="slot"></shared-quick-access-icon>
              </span>
              <span class="qa-tray-item__label-row">
                <span class="qa-tray-item__label">
                  {{ slot.customLabel || (slot.titleKey | translate) }}
                </span>
              </span>
            </div>
          } @else {
            <div
              class="qa-tray-item qa-tray-item--empty"
              [class.qa-tray-item--target]="pickedIndex !== null"
              cdkDrag
              [cdkDragDisabled]="true"
              (click)="onSlotTap($index)"></div>
          }
        }

        <div
          class="qa-tray-toggle-preview"
          [class.qa-tray-toggle-preview--visible]="navMode === navModeFloatingButton"
          aria-hidden="true">
          <i class="fa fa-bars"></i>
        </div>
      </div>
    }
  </div>

  <div class="qa-sheet__footer">
    <button type="button" class="qa-sheet__reset" (click)="resetToDefaults()">
      <i class="fa fa-refresh"></i>
      {{ 'mobileNav.customizeReset' | translate }}
    </button>

    <button type="button" class="btn btn-outline-secondary" (click)="cancel()">
      {{ 'btn.cancel' | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="confirm()">
      {{ 'btn.accept' | translate }}
    </button>
  </div>

  @if (iconPickerSlot; as pickerSlot) {
    <div class="qa-icon-picker" (click)="closeSlotEditor()">
      <div class="qa-icon-picker__panel" (click)="$event.stopPropagation()">
        <div class="qa-icon-picker__header">
          <span class="qa-icon-picker__title">
            {{ pickerSlot.customLabel || (pickerSlot.titleKey | translate) }}
          </span>
          <button type="button" class="qa-icon-picker__close" (click)="closeSlotEditor()">
            <i class="fa fa-times"></i>
          </button>
        </div>

        <div class="qa-icon-picker__field">
          <label class="qa-icon-picker__field-label" for="qaSlotTitleInput">
            {{ 'mobileNav.customizeTitleField' | translate }}
          </label>
          <input
            id="qaSlotTitleInput"
            type="text"
            class="qa-icon-picker__title-input"
            maxlength="24"
            [value]="editingValue"
            (input)="editingValue = $any($event.target).value"
            (keydown.enter)="closeSlotEditor()" />
        </div>

        <div class="qa-sheet__search qa-icon-picker__search">
          <i class="fa fa-search qa-sheet__search-icon"></i>
          <input
            type="text"
            class="qa-sheet__search-input"
            [placeholder]="'mobileNav.customizeIconSearchPlaceholder' | translate"
            [value]="iconSearchTerm"
            (input)="onIconSearchChange($any($event.target).value)" />
          @if (iconSearchTerm) {
            <button type="button" class="qa-sheet__search-clear" (click)="onIconSearchChange('')">
              <i class="fa fa-times"></i>
            </button>
          }
        </div>

        <div class="qa-icon-picker__grid">
          @for (icon of filteredIconChoices; track icon) {
            <button
              type="button"
              class="qa-icon-picker__option"
              [class.qa-icon-picker__option--active]="isCurrentIcon(icon)"
              (click)="selectIcon(icon)">
              @if (isFaIcon(icon)) {
                <i [ngClass]="faIconClass(icon)"></i>
              } @else {
                <shared-svg-icon [icon]="icon"></shared-svg-icon>
              }
            </button>
          }
        </div>

        @if (!filteredIconChoices.length) {
          <p class="qa-icon-picker__empty">
            {{ 'mobileNav.customizeNoResults' | translate }}
          </p>
        }

        <div class="qa-icon-picker__footer">
          @if (pickerSlot.customIcon) {
            <button type="button" class="qa-icon-picker__reset" (click)="resetIcon()">
              {{ 'mobileNav.customizeIconReset' | translate }}
            </button>
          }
          <button type="button" class="btn btn-primary btn-sm" (click)="closeSlotEditor()">
            {{ 'btn.accept' | translate }}
          </button>
        </div>
      </div>
    </div>
  }
</div>
